// src/utils.js

import { MEMBERSTACK_PUBLIC_KEYS } from "./constants";

/**
 * Returns the ordinal suffix for a given day of the month.
 * @param {number} day - The day of the month.
 * @returns {string} - The ordinal suffix ("st", "nd", "rd", or "th").
 */
export function getOrdinalSuffix(day) {
  if (day >= 11 && day <= 13) return "th";
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}

/**
 * Formats a Date object into a pretty string using UTC time.
 * Example: "Tuesday, 21st of February at 7pm"
 * @param {Date} dateTime - The date to format.
 * @returns {string} - The formatted date string.
 */
export function getPrettyDateTime(dateTime) {
  // Use UTC methods to extract date components
  const day = dateTime.getUTCDate();
  const suffix = getOrdinalSuffix(day);
  const weekday = dateTime.toLocaleString("en-US", { weekday: "long", timeZone: "UTC" });
  const month = dateTime.toLocaleString("en-US", { month: "long", timeZone: "UTC" });
 
  const time = "7pm" // MUST hard code the time here to avoid timezone issues!!!! (perhaps add the time into a config file or heroku config var)

  return `${weekday}, ${day}${suffix} of ${month} at ${time}`;
}

export function getMemberstackKey() {
  if (process.env.NODE_ENV === "production") {
    return MEMBERSTACK_PUBLIC_KEYS.prod;
  } else if (process.env.NODE_ENV === "development") {
    return MEMBERSTACK_PUBLIC_KEYS.dev;
  } else {
    throw new Error(`Unsupported NODE_ENV value: ${process.env.NODE_ENV}`);
  }
}
